module.exports = __webpack_public_path__ + "static/images/gold-big.e41ee94.png";